/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agb_Dispute_Resolution_TextInputs */

const en_agb_dispute_resolution_text = /** @type {(inputs: Agb_Dispute_Resolution_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We are neither willing nor obligated to participate in dispute resolution proceedings before a consumer arbitration board. The European Online Dispute Resolution platform (ODR) was discontinued on July 20, 2025.`)
};

const de_agb_dispute_resolution_text = /** @type {(inputs: Agb_Dispute_Resolution_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen. Die Europaeische Online-Streitbeilegungsplattform (OS-Plattform) wurde am 20. Juli 2025 eingestellt.`)
};

const fr_agb_dispute_resolution_text = /** @type {(inputs: Agb_Dispute_Resolution_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous ne sommes ni disposes ni obliges de participer a des procedures de reglement des litiges aupres d'un organisme de consommateurs.`)
};

const es_agb_dispute_resolution_text = /** @type {(inputs: Agb_Dispute_Resolution_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No estamos dispuestos ni obligados a participar en procedimientos de resolucion de disputas ante un organismo de consumidores.`)
};

const it_agb_dispute_resolution_text = /** @type {(inputs: Agb_Dispute_Resolution_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non siamo ne disposti ne obbligati a partecipare a procedure di risoluzione delle controversie presso un organismo dei consumatori.`)
};

const nl_agb_dispute_resolution_text = /** @type {(inputs: Agb_Dispute_Resolution_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wij zijn niet bereid en niet verplicht om deel te nemen aan geschillenbeslechtingsprocedures bij een consumentengeschillencommissie.`)
};

const pl_agb_dispute_resolution_text = /** @type {(inputs: Agb_Dispute_Resolution_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie jestesmy ani skłonni, ani zobowiazani do udzialu w postepowaniach przed organem ds. rozstrzygania sporow konsumenckich.`)
};

const fi_agb_dispute_resolution_text = /** @type {(inputs: Agb_Dispute_Resolution_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emme ole halukkaita emmekä velvollisia osallistumaan riidanratkaisumenettelyihin kuluttajariitalautakunnassa.`)
};

const da_agb_dispute_resolution_text = /** @type {(inputs: Agb_Dispute_Resolution_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi er hverken villige til eller forpligtede til at deltage i tvistbilaeggelsesprooedurer ved et forbrugertvistnavn.`)
};

const sv_agb_dispute_resolution_text = /** @type {(inputs: Agb_Dispute_Resolution_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi ar varken villiga eller skyldiga att delta i tvistlosningsforfaranden vid ett konsumenttvistorgan.`)
};

/**
* | output |
* | --- |
* | "We are neither willing nor obligated to participate in dispute resolution proceedings before a consumer arbitration board. The European Online Dispute Resolu..." |
*
* @param {Agb_Dispute_Resolution_TextInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const agb_dispute_resolution_text = /** @type {((inputs?: Agb_Dispute_Resolution_TextInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agb_Dispute_Resolution_TextInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_agb_dispute_resolution_text(inputs)
	if (locale === "fr") return fr_agb_dispute_resolution_text(inputs)
	if (locale === "es") return es_agb_dispute_resolution_text(inputs)
	if (locale === "it") return it_agb_dispute_resolution_text(inputs)
	if (locale === "nl") return nl_agb_dispute_resolution_text(inputs)
	if (locale === "pl") return pl_agb_dispute_resolution_text(inputs)
	if (locale === "fi") return fi_agb_dispute_resolution_text(inputs)
	if (locale === "da") return da_agb_dispute_resolution_text(inputs)
	if (locale === "sv") return sv_agb_dispute_resolution_text(inputs)
	return en_agb_dispute_resolution_text(inputs)
});